import {
  nominatedPurchasersKeys,
  useNodeService,
  useSelectedOrgId,
} from "@fero/hooks";
import { useQueryClient } from "@tanstack/react-query";

export const useSaveNominatedPurchaserDiscountMutation = () => {
  const nodeService = useNodeService();
  const queryClient = useQueryClient();
  const organisationId = useSelectedOrgId();
  return nodeService.savePurchaserDiscount.useMutation({
    onSuccess: () => {
      if (organisationId) {
        queryClient.invalidateQueries(
          nominatedPurchasersKeys.getNominatedPurchasersByOrg(organisationId),
        );
      }
    },
  });
};
